export default "__VITE_ASSET__kq0ByIYO__"